import * as React from "react";

export const PrivacySection = () => {
    const privacyUrl = "https://www.lvm.lv/privatuma-politika";

    return (
        <div className="privacy-section">
            <p>Nosūtot pieteikumu, Jūs iesniedzat savus personas datus.</p>
            <div>Pārzinis: AS “Latvijas valsts meži”.</div>
            <div>Kontaktinformācija: Vaiņodes iela 1, Rīga, LV-1004, e-pasts: lvm@lvm.lv, tālrunis 67610015.</div>
            <div>
                Datu apstrādes mērķis: Vērtēt un sniegt atbildi par pieteiktās aktivitātes vai pasākuma norises
                nosacījumiem.
            </div>
            <div>
                Papildus informācija par datu apstrādi pieejama &nbsp;
                <a className="url" href={privacyUrl} rel="noopener noreferrer" target="_blank">
                    Privātuma politikā.
                </a>
            </div>
        </div>
    );
};
